// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__xayCf","buttons":"SendReceipts_buttons__22CRP","email":"SendReceipts_email__HBrDE","bookApptTitle":"SendReceipts_bookApptTitle__2ozOg"};